import useJsaReportsEnabled from 'containers/jsa-reports/hooks/useJsaReportsEnabled/useJsaReportsEnabled';
import { useActiveMember } from 'hooks';
import { t } from 'utils/localize';

export default function useSafetyDashboardSettingsTitleLookup() {
  const member = useActiveMember();
  const isJsaReportsEnabled = useJsaReportsEnabled();
  const isJsaReportsViewable = isJsaReportsEnabled && member.position?.createSafetyAnalysisReports === true;

  return {
    incidents: t('Incidents'),
    inspections: t('Inspections'),
    training: t('Trainings'),
    observations: t('Observations'),
    jsaReports: isJsaReportsViewable ? t('JSA Reviews') : t('JSA Reports'),
  };
}
